<template>
    <div v-if="isLoading" class=" relative w-full bg-blend-color-burn    flex flex-col items-center align-middle justify-center max-h-screen " :class="showContact ? 'lg:col-span-6' :'lg:col-span-9' "
    style="background-image: url('/bg.png');background-size: cover;  " >

        <span>En cours de chargement</span>
    </div>
    <div v-else-if="!conversationShowIsSuccess && conversationShowShowMessage" class=" relative w-full bg-blend-color-burn    flex flex-col items-center align-middle justify-center max-h-screen " :class="showContact ? 'lg:col-span-6' :'lg:col-span-9' "
    style="background-image: url('/bg.png');background-size: cover;  " >

        <span>Une erreure s'est produite lors de l'enregistrement</span>
    </div>
    <div v-else-if="conversationShowItem?.id" class=" relative w-full bg-blend-color-burn    flex flex-col max-h-screen " :class="showContact ? 'lg:col-span-6' :'lg:col-span-9' "
        style="background-image: url('/bg.png');background-size: cover;  ">
        <UserInfo />

        <Messages />

        <Reply />
    </div>
    <Empty v-else />


</template>
<script>

// import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

import Reply from './components/Reply.vue';
import UserInfo from './components/UserInfo.vue';
import Messages from './components/Messages.vue';
import Empty from './components/Empty.vue';
import { mapActions } from 'vuex';

export default {
    name: "MessageIndex",
    props:{
        showContact:{
            type:Boolean,
            requierd:true
        }
    },
   
    components: {
        UserInfo,
        Messages,
        Reply,
        Empty
    },
   
    computed: {
        
        ...mapFields("messages/list", {
            messages: "items",
        }),
        ...mapFields("conversations/show", {
            conversationShowIsLoading:"isLoading",
            conversationShowShowMessage:"showMessage",
            conversationShowCurrentItem:"currentItem",
            conversationShowItem:"item",
            conversationShowIsSuccess:"isSuccess"
        }),
        ...mapFields("conversations/update", {
            conversationUpdateIsLoading:"isLoading",
            conversationUpdateIsSuccess:"isSuccess"

        }),
        ...mapFields("tickets/create", {
            ticketCreateIsLoading:"isLoading",
            ticketCreateIsSuccess:"isSuccess",
            ticketCreateIsCreated:"isCreated",
        }),
        isLoading(){
            return this.conversationShowIsLoading || this.conversationUpdateIsLoading || this.ticketCreateIsLoading
        },
        isSuccess(){
            return this.conversationShowIsSuccess || this.conversationUpdateIsSuccess || this.ticketCreateIsSuccess
        },

       

    },
    methods:{
        ...mapActions({
            getConversation: "conversations/show/getOne",
        }),
    },
    watch:{
       
        ticketCreateIsCreated(val) {
            if (val) {
                this.getConversation()
            }
        },
    }
    
}

</script>
